import { CUSTOMER_LEVEL } from '@wyz/types';
import { IBaseTyreOffer } from '~/purchase/types';
import { invariant, useQuery } from '@wyz/utils';
import { IUserCustomer } from '~/common/types';
import { PurchaseQueryKeys, useManageSearch } from '~/purchase/api';
import { PurchaseSearchHelpers } from '~/purchase/helpers';
import { useUpdateSearchQuery } from '~/purchase/hooks';
import { SEARCH_TYPE_ENUM } from '~/purchase/schemas';
import { IProductListState } from '~/purchase/types';

export function usePurchaseFilterProducts(
  listState: IProductListState,
  customer: IUserCustomer,
) {
  invariant(customer);
  const searchContext = {
    customerId: customer.id,
    searchType:
      customer.level === CUSTOMER_LEVEL.N1
        ? SEARCH_TYPE_ENUM.DISTRIBUTION
        : SEARCH_TYPE_ENUM.REDISTRIBUTION,
  };
  const { list } = useManageSearch<IBaseTyreOffer>({
    context: {
      customerId: customer.id,
      searchType:
        customer.level === CUSTOMER_LEVEL.N1
          ? SEARCH_TYPE_ENUM.DISTRIBUTION
          : SEARCH_TYPE_ENUM.REDISTRIBUTION,
    },
    list: listState.searchQuery
      ? {
          args: listState.searchQuery,
        }
      : undefined,
  });
  const products = list.data?.data ?? [];
  const query = useQuery<IBaseTyreOffer[]>({
    queryKey: PurchaseQueryKeys.search.filtered(
      customer?.id,
      searchContext.searchType,
      listState.searchQuery || {},
      { f: listState.filters, s: listState.sort, d: list.dataUpdatedAt },
    ),
    queryFn: () => {
      if (products.length === 0) {
        return [];
      }
      const filtered = PurchaseSearchHelpers.filterProducts(
        products,
        listState,
      );
      return PurchaseSearchHelpers.sortProducts(filtered, listState);
    },
    refetchOnWindowFocus: false,
    // keepPreviousData: true,
  });

  const updateQuery = useUpdateSearchQuery(
    searchContext.customerId,
    searchContext.searchType,
    listState,
  );

  return { query, updateQuery };
}
